import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { PlanSectionsComponent } from '@/app/components/projects/project-stages/plan-sections/plan-sections.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Stage2viewmodeComponent } from '@/app/components/projects/project-stages/plan-sections/stage2viewmode/stage2viewmode.component';
import { Stage1viewmodeComponent } from '@/app/components/projects/project-stages/project-brief/stage1viewmode/stage1viewmode.component';
import { OverviewComponent } from '@/app/components/projects/project-stages/project-brief/add-project-module/brief-sections/overview/overview.component';
import { CostEstimationComponent } from '@/app/components/projects/project-stages/plan-sections/cost-estimation/cost-estimation.component';
import { MatIconModule } from '@angular/material/icon';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { GetStagesService } from '@/app/services/get-stages.service';
import { NgToastService } from 'ng-angular-popup';
import { DesignDocumentsComponent } from '../project-design/design-documents/design-documents.component';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [
    MatExpansionModule,
    PlanSectionsComponent,
    CommonModule,
    Stage2viewmodeComponent,
    Stage1viewmodeComponent,
    OverviewComponent,
    CostEstimationComponent,
    MatIconModule,
    DesignDocumentsComponent,
  ],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements OnInit {
  projectId: any;
  stages: any;
  isEdit = false;
  Stage1OpenState = false;
  Stage2OpenState = false;
  Stage3OpenState = false;
  hideStage2viewmode = true;
  hideStage3viewmode = true;

  showStage1ViewMode = false;
  showStage2ViewMode = false;
  showStage3ViewMode = false;

  constructor(
    private router: Router,
    private getProjectIdService: GetProjectIdService,
    private getStagesService: GetStagesService,
    private toast: NgToastService
  ) {}

  ngOnInit() {
    this.checkUrlAndExpandPanels();
    this.projectId = this.getProjectIdService.getProjectId();
    this.stages = this.getStagesService.getStages();
    this.Stage1OpenState = true;
  }
  handleEdit() {
    console.log('The handle edit page is called');
    this.isEdit = true;
  }

  checkUrlAndExpandPanels() {
    const currentUrl = this.router.url;

    if (currentUrl === '/stage2nav') {
      // Automatically open Stage 2, and show Stage 1 and Stage 3 view modes
      this.Stage2OpenState = true;
      this.hideStage3viewmode = false;
      this.showStage1ViewMode = true; // Show Stage 1 view mode
      this.showStage3ViewMode = true; // Show Stage 3 view mode
    } else if (currentUrl === '/stage3nav') {
      // Open Stage 3, show Stage 1 and Stage 2 view modes
      this.Stage3OpenState = true;
      this.showStage1ViewMode = true; // Show Stage 1 view mode
      this.showStage2ViewMode = true; // Show Stage 2 view mode
    }
  }
  setStagesValues(stages: any) {
    console.log('The updated values of stages is:', stages);
    this.stages = stages;
    if (stages.stage1 && !stages.stage2) {
      this.Stage1OpenState = false;
      this.Stage2OpenState = true;
    } else if (stages.stage2 && stages.stage2) {
      this.Stage2OpenState = false;
      this.Stage3OpenState = true;
    } else {
      this.Stage3OpenState = false;
    }
  }

  /**
   * TODO:
   * Needs further optimization. we should only have a stage variable and it should do all things
   */
  onStageOpen(stage = 1): void {
    if (stage !== 1 && !this.stages.stage1) {
      this.toast.warning(
        'Add the project brief first, then this stage will be open',
        'WARNING',
        4000
      );

      return;
    }

    if (stage == 1) {
      localStorage.setItem('currentStage', JSON.stringify(1));
      this.Stage1OpenState = true;
      this.Stage2OpenState = false;
      this.Stage3OpenState = false;
    } else if (stage == 2) {
      localStorage.setItem('currentStage', JSON.stringify(2));
      this.Stage2OpenState = true;
      this.Stage1OpenState = false;
      this.Stage3OpenState = false;
    } else if (stage == 3) {
      localStorage.setItem('currentStage', JSON.stringify(3));
      this.Stage3OpenState = true;
      this.Stage1OpenState = false;
      this.Stage2OpenState = false;
    } else {
      // TODO: redirect to home page
      this.Stage2OpenState = false;
      this.Stage1OpenState = false;
      this.Stage3OpenState = false;
    }
  }
}
